// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteAppSystemWebApiRequestModel from '../../model/delete-app-system-web-api-request-model';
import DeleteAppSystemWebApiRequestDTO from '../dto/delete-app-system-web-api-request-dto';
import dtoSchema from '../schemas/delete-app-system-web-api-request-schema';

export default abstract class DeleteAppSystemWebApiRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteAppSystemWebApiRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteAppSystemWebApiRequestDTO>): DeleteAppSystemWebApiRequestModel;
  static toModel(dto: DeepPartial<DeleteAppSystemWebApiRequestDTO> | undefined | null): DeleteAppSystemWebApiRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteAppSystemWebApiRequestDTO> | undefined | null): DeleteAppSystemWebApiRequestModel | undefined {
    return dto ? new DeleteAppSystemWebApiRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteAppSystemWebApiRequestModel> | DeleteAppSystemWebApiRequestModel): DeleteAppSystemWebApiRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteAppSystemWebApiRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteAppSystemWebApiRequestModel, can not map to DeleteAppSystemWebApiRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
